import { UpperCasePipe } from "@angular/common";
import { Component, effect, ElementRef, ViewChild } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { Router } from "@angular/router";
import { QRCodeComponent } from "angularx-qrcode";
import { UserService } from "app/services/user.service";
import * as htmlToImage from "html-to-image";
import { toast } from "ngx-sonner";
import { Subject } from "rxjs";

@Component({
  selector: "app-profile-qr-code",
  imports: [QRCodeComponent, UpperCasePipe, MatIcon],
  templateUrl: "./profile-qr-code.component.html",
  standalone: true,
})
export class ProfileQrCodeComponent {
  @ViewChild("qrContainer", { static: true }) qrContainer: ElementRef;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  protected toast = toast;
  public businessCardUrl: string;
  public currentRoute: string;
  public profile;
  public isLoading = false;

  constructor(
    private _userService: UserService,
    public dialogRef: MatDialogRef<ProfileQrCodeComponent>,
    private router: Router
  ) {
    effect(() => {
      const user = this._userService.user();

      if (user) {
        this.currentRoute = user.userId;

        this.businessCardUrl = `${window.location.origin}/p/${user.userId}`;
        this.profile = user;
      }
    });
  }

  async share() {
    this.isLoading = true;

    const IS_SAFARI = /^((?!chrome|android).)*safari/i.test(
      navigator.userAgent
    );

    let TEXT = "Tap into the link to see my business card:";

    if (!navigator.share) {
      this.toast.error("Sharing is not supported");
      this.isLoading = false;
    }

    const qrContainer = this.qrContainer.nativeElement;

    const filterFunction = (node) => {
      return node.id !== "button";
    };

    let scale = 2;

    const options = {
      filter: filterFunction,
      height: qrContainer.clientHeight * scale,
      width: qrContainer.clientWidth * scale,
      style: {
        transform: "scale(" + scale + ")",
        transformOrigin: "top left",
      },
    };

    htmlToImage.toBlob(qrContainer, options).then((res) => {
      const file = new File([res], "qrcode.png", { type: "image/png" });

      let data = IS_SAFARI
        ? { files: [file] }
        : { files: [file], text: TEXT, url: this.businessCardUrl };

      navigator
        .share(data)
        .then(() => {
          if (IS_SAFARI) {
            let dataText = {
              text: TEXT,
              url: this.businessCardUrl,
            };
            navigator.share(dataText);
          }
          this.isLoading = false;
        })
        .catch(function (err) {
          this._toastrService.error("Error sharing:", err);
          this.isLoading = false;
        });
    });
  }

  async buildPng(node: HTMLElement, options) {
    let dataUrl = "";
    const minDataLength = 2000000;
    let i = 0;
    const maxAttempts = 10;
    dataUrl = await htmlToImage.toPng(node, options);
    while (dataUrl.length < minDataLength && i < maxAttempts) {
      await new Promise((resolve) => {
        setTimeout(() => resolve(null), 300);
      });
      dataUrl = await htmlToImage.toPng(node, options);
      i += 1;
    }

    return dataUrl;
  }

  navigateToBusinessCard() {
    this.router
      .navigate([`p/${this.currentRoute}`])
      .then(() => this.closeDialog());
  }

  closeDialog() {
    this.dialogRef.close();
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
